import { AmplitudeCategories, createTrackerForCategory } from "./amplitude";
import type Stripe from "stripe";
import { BaseApiError } from "apis/_sdk/types/errors";
import * as StripeUtils from "common/utils/stripeUtils";

const trackEvent = createTrackerForCategory(AmplitudeCategories.PaymentMethod);

enum events {
    VerificationFail = "VerificationFail",
    VerificationSuccess = "VerificationSuccess"
}

export const PaymentMethod = {
    VerificationFail: async (error: BaseApiError) => {
        const eventProperties = {
            workspace_id: "all",
            error_type: error.responseBody?.error_type ?? error.name ?? "unknown",
            decline_code: error.responseBody?.decline_code ?? "unknown",
            funding_type: error.responseBody?.funding_type ?? "unknown",
            payment_type: error.responseBody?.payment_type ?? "unknown"
        };

        trackEvent(events.VerificationFail, eventProperties, { audit: true });
    },
    VerificationSuccess: async ({ paymentMethod, workspaceId }: { paymentMethod: Stripe.PaymentMethod, workspaceId: string }) => {
        const eventProperties = {
            payment_type: StripeUtils.PaymentMethod.getPaymentType(paymentMethod),
            funding_type: StripeUtils.PaymentMethod.getFundingType(paymentMethod),
            workspace_id: workspaceId,
        };

        trackEvent(events.VerificationSuccess, eventProperties, { audit: true });
    },
};
